/** HTML IDs for general app elements */
export enum HtmlId {
    App = 'sails-app',
    Error = 'sails-error-wrapper',
    Loading = 'sails-loading-spinner',
}
